import PropTypes from 'prop-types';
import { connectComponent } from '../../lib/connectComponent';
import Project from '../../entities/project';

import AssetDropFilesIndicatorBox
	from '../../components/assets/AssetsDropFilesIndicatorBox/AssetsDropFilesIndicatorBox';
import { getProject } from '../../selectors/projects';
import { getFolder } from '../../selectors/folders';
import { getAsset } from '../../selectors/assets';
import Folder from '../../entities/folder';
import Asset from '../../entities/asset';

export const AssetDropFilesIndicatorBoxContainer = ( {
	project, folder, asset, uploadingRoundForAsset, currentUserCanUploadAssets,
	isLimitedEditor, onRequestSeat
} ) => (
	<AssetDropFilesIndicatorBox
		projectName={project?.name}
		folderName={folder?.name}
		assetName={asset?.name}
		uploadingRoundForAsset={uploadingRoundForAsset}
		currentUserCanUploadAssets={currentUserCanUploadAssets}
		isLimitedEditor={isLimitedEditor}
		onRequestSeat={onRequestSeat}
	/>
);

AssetDropFilesIndicatorBoxContainer.propTypes = {
	project: PropTypes.instanceOf( Project ),
	folder: PropTypes.instanceOf( Folder ),
	asset: PropTypes.instanceOf( Asset ),
	uploadingRoundForAsset: PropTypes.bool,
	currentUserCanUploadAssets: PropTypes.bool,
	isLimitedEditor: PropTypes.bool,
	onRequestSeat: PropTypes.func
};

AssetDropFilesIndicatorBoxContainer.defaultProps = {
	project: undefined,
	folder: undefined,
	asset: undefined,
	uploadingRoundForAsset: false,
	currentUserCanUploadAssets: true,
	isLimitedEditor: false,
	onRequestSeat: undefined
};

export default connectComponent( ( state, props ) => ( {
	project: getProject( state, props ),
	folder: getFolder( state, props ),
	asset: getAsset( state, props )
} ) )( AssetDropFilesIndicatorBoxContainer );
